import { useEffect, useState, useContext } from "react"
import { Box, Chip, Grid, IconButton, Typography } from "@mui/material"
import { useTheme } from '@mui/material/styles';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { ButtonBasic, TableBase } from "../../components"
import { showModal } from "react-redux-modal-provider";
import { SocketContext } from "../../context/SocketContext";
import ModalSubTipoTicket from "../../modals/admTicket/ModalSubTipoTicket";
import SubTipoTicketService from "../../services/subTipoTicket.service";
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import ConfirmationDialog from "../../modals/default/ConfirmationDialog";

const SubTipoTicketScreen = () => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [items, setItems] = useState([]);
    const { sockets } = useContext( SocketContext );
    const actualizar = async() =>{
        await SubTipoTicketService.getAll({all: true}).then((resp)=>{
            setItems(resp)
        })
    }

    const columns = [
        {
            name: "id_sttk",
            label: "ID",
            options: {
                filter: false,
                sort: false,
                display:false,
                viewColumns: false
            }
        },
        {
            name: "nombre_sttk",
            label: "Nombre",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: 'isDeleted_sttk',
            label: "Estado",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    if(!value){
                    return <Chip label="Activo" color="success" />
                    }
                    return <Chip label="Inactivo" color="error" />
                }
            }
        },
        {
            name: 'actions',
            label: "Acciones",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => (
                    <>
                        <Box display='flex'>
                            <IconButton aria-label="edit" onClick={()=>onOpenEditar(tableMeta.rowData[0])}>
                                <EditIcon fontSize="medium" sx={{color: isDarkMode ? '#90caf9' : '#0364ff'}} />
                            </IconButton>
                            <IconButton aria-label="edit" onClick={()=>onEliminar(tableMeta.rowData[0])}>
                                { !tableMeta.rowData[2] ?(
                                    <DeleteIcon fontSize="medium" sx={{color: isDarkMode ? '#f87171' : '#e01010'}} />
                                ):(
                                    <PublishedWithChangesIcon fontSize="medium" sx={{color: isDarkMode ? '#4ade80' : '#018155'}} />
                                )}
                            </IconButton>
                        </Box>
                    </>
                )
            }
        }
    ];
    const onGuardar = () => {
        actualizar();
        sockets?.emit('newSubTipoTK');
    };
    const onOpenEditar = (item) => {
        if(item){
            const searchItem = items.find((sItem)=> sItem.id_sttk === item)
            showModal(ModalSubTipoTicket, {item: searchItem, onGuardar: onGuardar});
        }else{
            showModal(ModalSubTipoTicket, {onGuardar: onGuardar});
        }
    };
    const onEliminar = (item) => {
        const searchItem = items.find((sItem)=> sItem.id_sttk === item)
        showModal(ConfirmationDialog, {
            title: `${searchItem?.isDeleted_sttk ? 'Activar' : 'Eliminar'} el Sub-Tipo de Ticket`,
            message: `¿Esta seguro que desea ${searchItem?.isDeleted_sttk ? 'activar' : 'eliminar'} el Sub-Tipo de Ticket?`,
            onConfirm: () => {
                SubTipoTicketService.destroy(searchItem.id_sttk).then(() => {
                    onGuardar();
                });
            }
        });
    };
    useEffect(() => {
        actualizar();
        document.title = 'Sub-Tipo Ticket';
    }, [])

    return (
        <Box sx={{width:'100%',height: '100%',overflow:'auto', background: isDarkMode ? '#1a2332' : '#f5f5f5'}}>
            <Grid container p={3} display='flex' justifyContent='center'>
                <Grid item xs={6}>
                    <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000', fontWeight: 'bold'}} variant="h2">Sub-Tipo de Ticket</Typography>
                </Grid>
                <Grid item xs={6} sx={{display: 'flex', justifyContent: 'end'}}>
                    <ButtonBasic
                        textButton="NUEVO"
                        sx={{width: 200, height: 30}}
                        onClick={()=>onOpenEditar()}
                        variant='wk'
                        color="nextStep"
                    />
                </Grid>
                <Grid item xs={12} md={6} mt={2} sx={{marginBottom: 15}}>
                    <TableBase title='Resultados' columns={columns} data={items} />
                </Grid>
            </Grid>
        </Box>
    )
}

export default SubTipoTicketScreen